import * as React from "react";

import classNames from "classnames";

import DocInlineText from "./InlineText";

interface DocCheckboxProps extends CheckboxNode, EveryNodeArgs {}

export default function DocCheckbox(props: DocCheckboxProps) {
  const onChanged: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    props.currentUser.addState({[e.target.id]: {"value": e.target.checked}});
  };

  const onClick: React.MouseEventHandler<HTMLInputElement | HTMLLabelElement> = (e) => {
    e.stopPropagation();
  };

  return (
    <div className={classNames("doc-checkbox", {"inactive": props.inactiveBoolean})}>
      <input type="checkbox" id={props.uid} disabled={props.inactiveBoolean} checked={props.value} onChange={onChanged} onClick={onClick}/>
      <label htmlFor={props.uid} onClick={onClick}>
        <span className="doc-checkbox-outer"><span className="doc-checkbox-inner" /></span>
        <span className="doc-checkbox-title">
          <DocInlineText content={props.content} uid={props.uid} contentKey="content" editState={props.editState}/>
        </span>
      </label>
    </div>
  );
}
